module.exports = __webpack_public_path__ + "static/media/college.a202a4a7.svg";